<template>
    <Page header="Инвойсы" type="" :nopadding="false" header_pos="left">
        <template #body>
            <!-- <OrdersStat /> -->
            <div v-if="!loading && list" class="w-full">
                <OrderList 
                    :orders="list"
                    :filters="filters"
                    :totalRecords="totalRecords" 
                    :defaultParams="lazyParams"
                    :loading="loading" 
                    @filter="setFilter" 
                    @lazyParams="setParams" />
            </div>
            <Skeleton v-else width="100%" height="30px" />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import OrderList from '@/components/personal/order_list.vue'
import Page from '@/components/public/page.vue'
import OrdersStat from '@/components/personal/orders_stat.vue'

export default {
    data() {
        return {
            loading: false,
            list: null,
            rows: 10,
            totalRecords: 0,
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                _id: {value: '', matchMode: 'contains'}, 
                user_id: {value: '', matchMode: 'contains'},
                client_id: {value: '', matchMode: 'contains'},
                ext_order_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                status: {value: '', matchMode: 'contains'},
                bank_code: {value: '', matchMode: 'contains'},
                subscription_id: {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            },
        }
    },
    components: {
        OrderList,
        Page,
        OrdersStat
    },
    computed: {
        stateTotalOrders: function () { return this.$store.getters.StateTotalOrders },
        stateTotalAmount: function () { return this.$store.getters.StateTotalAmount },
        stateAmountByStatus: function () { return this.$store.getters.StateAmountByStatus },
        stateCountByStatus: function () { return this.$store.getters.StateCountByStatus },
        stateRate: function () { return this.$store.getters.StateRate },
    },
    methods: {
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadOrders();
        },
        setParams(params) {
            this.lazyParams = params
            this.LoadOrders()
        },
        onPage(event) {
            this.lazyParams = event
        },
        async LoadOrders() {
            this.loading = true
            try { 
                window.scrollTo({ top: 0, behavior: 'smooth' })
                const orders = await this.connect.GetPersonalOrders(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res=>res)
                if(orders.result) {
                    this.list = orders.data
                    this.totalRecords = orders.total
                } else {
                    this.list = []
                    this.totalRecords = 0
                    this.showMess('error', 'Ошибка', 'Ошибка при загрузке заказов')
                }
            } catch (e) {
                console.error(e)
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters

        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.subscription_id) this.filters.subscription_id = {value: query.subscription_id, matchMode: 'contains'}

        this.LoadOrders()
    },
}
</script>